export const enum SnCameraManagementType {
  Managed = 'Managed',
  Unmanaged = 'Unmanaged',
  External = 'External',
}
